import React, { useEffect, useRef, useState } from "react";
import Sidebar, {SidebarRef} from "./Sidebar.tsx";
import { useSwipeable } from "react-swipeable";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
export default function Projects() {
    const dirs = [ 
        "Overview",
        "Elixir-Terminal-Translator",
        "Bevy-Graphs",
        "Tax-Knight",
    ]

    const sideBarRef = useRef<SidebarRef>(null);

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            if(sideBarRef.current?.getIsOpen()) {
                sideBarRef.current.toggleSidebar();
            }
        },
        onSwipedRight: () => {
            if(!sideBarRef.current?.getIsOpen()) {
                sideBarRef.current?.toggleSidebar();
            }
        },
        preventScrollOnSwipe: true,
    })
    const markdown = `# Overview \n Note that this Website is still a work in progress and descriptions will be added soon `
    const [ett_md, set_ett_md] = useState("Loading...");
    const [bvy_md, set_bvy_md] = useState("Loading...");
    
    const fetchUrl = (url, setFn) => {
        // Fetch the .md file from the public folder
        fetch(url)
          .then(response => response.text())  // Get the content as text
          .then(data => {
            setFn(data);  // Store it in the state
          })
          .catch(error => console.error('Error fetching .md file:', error));
    }
    
    useEffect(() => {
        fetchUrl('https://raw.githubusercontent.com/Maupse/SlimeBucket/refs/heads/master/README.md', set_ett_md);
        fetchUrl('https://raw.githubusercontent.com/Maupse/bevy_graph_simulator/refs/heads/master/README.md', set_bvy_md);

    }, []);

    return (
        <div className="min-h-screen flex flex-1 overflow-hidden">
            <Sidebar dirs={dirs} title={"Projects"} ref={sideBarRef}/>
            <div className="flex-1 p-6 overflow-y-auto h-screen">
                <div className="markdown">
                    <section id="Overview">
                       <Markdown>{markdown}</Markdown> 
                    </section>
                    <section id="Elixir-Terminal-Translator">
                        <Markdown remarkPlugins={[remarkGfm]}>{ett_md}</Markdown> 
                    </section>
                    <section id="Bevy-Graphs">
                        <Markdown remarkPlugins={[remarkGfm]}>{bvy_md}</Markdown>
                    </section>
                    <section id="Tax-Knight">
                        <Markdown>{`# Tax Knight \n A little project to test out 2d game creation in [Godot Engine](https://godotengine.org/).  
**[Play the game](/projects/taxknight)**`}</Markdown>
                    </section>
                </div>
            </div>
        </div>
    )
}